module.exports = __webpack_public_path__ + "img/bg.c15028e1.png";